import styled, { css } from 'styled-components'
import theme from 'theme_'
import { Font14, Font16, Secondary } from 'components/Typography'
import { CommonLinkButton } from 'components/Button'

export const NetworkStatusClientsContainer = styled.div``

export const NetworkStatusClientsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const NetworkStatusClientsHeaderTitle = styled(Secondary)`
  display: flex;
  flex-direction: row;
  color: ${theme.colors.otterWarmBlack};
  ${Font16};
  font-weight: 900;
`

export const NetworkStatusClientsBody = styled.div`
  display: flex;
  gap: ${theme.spacing.base};
  @media ${theme.devices.tabletLandscape} {
    flex-direction: row;
    gap: ${theme.spacing.xs};
  }
`

const NetworkStatusClientsItemBase = css`
  width: 100%;
`

export const NetworkStatusClientsItem = styled.div<{
  disabled?: boolean
}>`
  justify-content: start;
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  ${NetworkStatusClientsItemBase};
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.base};
  color: ${(p) => p.disabled && theme.colors.darkeyGrey};
`

export const NetworkStatusClientsIcon = styled.img`
  width: 52px;
  height: 38px;
  color: ${theme.colors.black};
`

export const NetworkStatusClientsForwardIcon = styled.img`
  width: 15;
  height: 15;
  color: ${theme.colors.black};
`

export const NetworkStatusClientsItemHeader = styled.div`
  font-weight: 900;
`

export const NetworkStatusClientsCount = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  color: ${theme.colors.otterWarmBlack};
  font-size: 40px;
  font-weight: 900;
`

export const NetworkStatusClientsCountLabel = styled.div`
  display: flex;
  flex-direction: row;
  flex-flow: row nowrap;
  margin-top: 15px;
  color: ${theme.colors.moreGrey};
  ${Font16};
`

export const NetworkStatusClientsItemFooter = styled.div`
  ${Font14};
  display: flex;
  justify-content: flex-end;
  font-weight: 900;
`

export const NetworkStatusClientsForwardButton = styled(CommonLinkButton)`
  display: flex;
  justify-content: flex-end;
  float: right;
`
